import ReactRouterLink from './ReactRouterLink';

export default ReactRouterLink;
